import type {
  RelatedService,
  RelatedServiceResponse,
  Response,
  Response200Ok,
  ResponseWithError,
} from '../types';

export function processFetchedResult<T extends Response>(
  response: T,
): T extends Response200Ok ? RelatedService[] : ResponseWithError {
  let result;

  if ('relatedServices' in response) {
    result = response.relatedServices.map((item): RelatedServiceResponse => {
      return {
        iconLeftSrc: item.imageUrl,
        title: item.title,
        description: item.message,
        price: {
          value: item.price,
          currencySlug: item.currency,
        },
        serviceKey: item.serviceKey,
        serviceId: item.serviceId,
        categoryId: item.categoryId,
        serviceHref: item.serviceURL,
        sales: item.sales,
        isCompensationEnabled: item?.isCompensationEnabled,
      };
    });
  } else {
    result = response;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return result as any;
}
